import { Helmet } from "react-helmet"
import Layout from "../components/layout/Layout"
import Brand1 from "../components/sections/Brand1"
import ServiceDetails4 from "../components/sections/ServiceDetails4"
import Imgsec2 from "../components/sections/imgsec2"
export default function ServicesDetails() {
	return (
		<>
			<Helmet>
				<title>V-Make | WPC UV Digital Series</title>
				<meta name="description" content="Explore V-Make's WPC UV Digital Series – printed WPC panels with vibrant designs and UV coating. Perfect for stylish, durable interiors and exterior cladding." />
				<meta name="keywords" content="WPC UV Digital Series, printed WPC panels, UV coated WPC board, decorative digital WPC, V-Make printed panels, interior digital boards, exterior UV boards, moisture resistant printed WPC" />
				<link rel="canonical" href="https://vmakewpc.com/Wpc-UV-Digital-Series" />
				<meta property="og:title" content="WPC UV Digital Series | V-Make" />
				<meta property="og:description" content="Discover our WPC UV Digital Series – beautifully printed and UV-protected WPC boards ideal for modern interior walls, furniture, and more." />
				<meta property="og:url" content="https://vmakewpc.com/Wpc-UV-Digital-Series" />
				<meta property="og:image" content="https://vmakewpc.com/assets/img/service/Digital%20door-1.jpg" />
			</Helmet>
			<Layout
				headerStyle={1}
				footerStyle={1}
			// breadcrumbTitle="Services details"
			>
				<ServiceDetails4 />
				<Imgsec2 />
			</Layout>
		</>
	)
}
